// react
import React from "react";
import {Button, Table} from "react-bootstrap";

// local
import {
	FreshdeskCompany,
	FreshdeskTicket,
	API_FRESHDESK_PAGE_SIZE
} from "../../types";

/**
 * FreshdeskEngagement
 */

interface EngagementProps {
	companies: FreshdeskCompany[],
	item: FreshdeskTicket,
}

const FreshdeskEngagement = (props: EngagementProps) => {

	// setup
	const {companies, item} = props;
	const priorities = [
		'low',
		'medium',
		'high',
		'urgent'
	];
	const statuses = [
		'unknown',
		'open',
		'pending',
		'resolved',
		'closed',
		'waiting'
	];

	// item details
	const tags = item.tags.join(',');
	const status = item.status ? statuses[item.status-1] : '';
	const priority = priorities[item.priority-1];
	const options:Intl.DateTimeFormatOptions = { year: '2-digit', month: '2-digit', day: '2-digit' };
	const timestamp = item.created.toLocaleString('en-US', options);
	const company = companies.find(c => {
		return c.id === item.company_id;
	});

	const typeClass = item.type ? 'type' : 'type missing';
	const categoryClass = item.category ? 'type' : 'missing';
	const companyClass = company ? 'company' : 'company missing';
	const companyName = company ? company.name : (item.company_id ? `*${item.company_id}*` : '*anonymous*');
	const href = 'https://blunovus.freshdesk.com/a/tickets/'+item.id;

	// render
	return (
		<tr key={'freshdesk-'+item.id}>
			<td className={"ticket"}><a href={href} target="_blank" rel="noreferrer">{item.id}</a></td>
			<td className="date">{timestamp}</td>
			<td className={companyClass}>{companyName}</td>
			<td className={typeClass}>{item.type ? item.type : '*missing*'}</td>
			<td className={categoryClass}>{item.category ? item.category : '*undefined*'}</td>
			<td className="status">{status}</td>
			<td className="outcome">{item.outcome}</td>
			<td className="priority">{priority}</td>
			<td className="description">{item.subject}</td>
			<td className="tags">{tags}</td>
		</tr>
	);
}

/**
 * FreshdeskEngagements
 *      Note: Freshdesk API interface https://developers.freshdesk.com/api/
 */

interface EngagementsProps {
	companies: FreshdeskCompany[],
	tickets: FreshdeskTicket[],
	referrals: number,
	ticketPage: number,
	ticketCount: number,
	pageNext: () => void,
	pagePrev: () => void,
}
interface EngagementsState {
	referral: number
}

export class FreshdeskEngagements extends React.Component<EngagementsProps, EngagementsState> {

	/*****************************************************************************************************************
	 * RENDER FUNCTIONS are in the section below.
	 *****************************************************************************************************************/

	render() {
		// setup
		const {companies, tickets, ticketCount, ticketPage, pageNext, pagePrev, referrals} = this.props;

		// header
		const header = <thead key='freshdesk-header'>
			<th className="ticket">#</th>
			<th className="date">Created</th>
			<th className="company">Company</th>
			<th className="type">Type</th>
			<th className="type">Employee</th>
			<th className="status">Status</th>
			<th className="outcome">Outcome</th>
			<th className="priority">Priority</th>
			<th className="description">Description</th>
			<th className="tags">Tags</th>
		</thead>;

		// Construct the list.
		const start = (ticketPage * API_FRESHDESK_PAGE_SIZE);
		const end = (start + API_FRESHDESK_PAGE_SIZE) > ticketCount ? ticketCount : (start + API_FRESHDESK_PAGE_SIZE);
		const summary = <Button className="btn-page" variant="forgot" size="sm">{start+1} - {end} of {ticketCount}</Button>;
		const prev = ticketPage
			? <Button className="btn-page" variant="forgot" size="sm" onClick={pagePrev}>&lt;&lt;</Button>
			: '';
		const next = (end < ticketCount)
			? <Button className="btn-page" variant="forgot" size="sm" onClick={pageNext}>&gt;&gt;</Button>
			: '';

		let body = [];
		if (start < end) {
			for (let i = start; i < end; i++) {
				const item = tickets[i];
				body.push(<FreshdeskEngagement companies={companies} item={item}/>);
			}
		} else {
			body.push(<tr key={'freshdesk-empty'}>
				<td className="warning" colSpan={10}>No Activity</td>
			</tr>);
		}

		let footer = (start < end) ?
			<tfoot key='freshdesk-footer'><tr>
				<td colSpan={6}/>
				<td className='outcome'>{`referrals=${referrals}`}</td>
				<td></td>
				<td className="btn-page">{prev} {summary} {next}</td>
				<td></td>
			</tr></tfoot> :
			null;

		// render
		return (
			<div id="FreshdeskEngagements">
				<Table id="FreshdeskEngagements-Table" striped bordered responsive>
					{header}
					<tbody>
						{body}
					</tbody>
					{footer}
				</Table>
			</div>
		);
	}

}

